module.exports = __webpack_public_path__ + "static/media/all_threads.1c4a0b35.svg";